import React from 'react';
import PromisedDonerComponent from '../Component/PromisedDonerComponent/PromisedDonerComponent';

function PromisedPage(props) {
    return (
        <>
            <PromisedDonerComponent />
        </>
    );
}

export default PromisedPage;